import CreateDiscovery from "./CreateDiscovery";

export default CreateDiscovery;
